// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "static/js/3d1bf34fcfd2b6456185.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"300898400dae240b8179","154":"eb2baa38f79f08b2eb4e","155":"d8f3ce427a767b9dfd2c"}[chunkId] + ".chunk.js";
};